import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/v1/attendances/validate").POST();

export async function validateAttendances(attendanceIds: string[]) {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));
    const req: typeof endpoint.types.Req = { attendanceIds };
    const res = await call({ req });
    const rejectedAttendanceIds =
        "rejectedAttendanceIds" in res && Array.isArray(res.rejectedAttendanceIds)
            ? res.rejectedAttendanceIds
            : [];

    return {
        rejectedAttendanceIds,
    };
}
